module.exports = __webpack_public_path__ + "img/skypets-6.85d5254a.jpg";